import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalendarHeader = ({ 
  currentDate, 
  onPrevMonth, 
  onNextMonth, 
  viewMode, 
  onViewModeChange,
  onTodayClick,
  className = '' 
}) => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const formatMonthYear = (date) => {
    return `${monthNames?.[date?.getMonth()]} ${date?.getFullYear()}`;
  };

  return (
    <div className={`flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-4 lg:p-6 bg-surface border-b border-border ${className}`}>
      {/* Month Navigation */}
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="icon"
            onClick={onPrevMonth}
            className="hover-lift"
          >
            <Icon name="ChevronLeft" size={20} />
          </Button>
          
          <h2 className="text-xl lg:text-2xl font-semibold text-text-primary min-w-[200px] text-center">
            {formatMonthYear(currentDate)}
          </h2>
          
          <Button
            variant="outline"
            size="icon"
            onClick={onNextMonth}
            className="hover-lift"
          >
            <Icon name="ChevronRight" size={20} />
          </Button>
        </div>

        <Button
          variant="ghost"
          size="sm"
          onClick={onTodayClick}
          iconName="Calendar"
          iconPosition="left"
          className="hidden sm:flex"
        >
          Today
        </Button>
      </div>

      {/* View Controls */}
      <div className="flex items-center space-x-2">
        <div className="flex items-center bg-muted rounded-lg p-1">
          <Button
            variant={viewMode === 'calendar' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('calendar')}
            iconName="Calendar"
            iconPosition="left"
            className="rounded-md"
          >
            Calendar
          </Button>
          <Button
            variant={viewMode === 'list' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onViewModeChange('list')}
            iconName="List"
            iconPosition="left"
            className="rounded-md"
          >
            List
          </Button>
        </div>

        {/* Mobile Today Button */}
        <Button
          variant="outline"
          size="icon"
          onClick={onTodayClick}
          className="sm:hidden"
        >
          <Icon name="Calendar" size={20} />
        </Button>
      </div>
    </div>
  );
};

export default CalendarHeader;